import {
  Error as GraphQLErrorResult,
  isError,
} from '@spotify/confidence-graphql';

export const hasRelation = (
  resource:
    | Maybe<{
        resourceRelations?:
          | Maybe<{
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations?: { relation: string }[];
            }>
          | ({
              __typename: 'Error';
            } & GraphQLErrorResult);
      }>
    | undefined,
  relation: string,
): boolean => {
  if (!resource) return false;
  if (isError(resource?.resourceRelations)) return false;
  return (
    resource?.resourceRelations?.resourceRelations?.some(
      r => r.relation === relation,
    ) ?? false
  );
};
